import Vue from 'vue';
import RegistrationForm from '@/components/pages/RegistrationPage/RegistrationForm.vue'

Vue.component('registration-form', RegistrationForm);
